import React, { useEffect, useState } from 'react';

import Dashboard from 'components/Dashboard/Dashboard';
import { gql } from '@apollo/client';
import { useMutation, useQuery } from 'hooks/apollo';
import RoutedLayout from 'components/Layout/RoutedLayout';
import { Button, Form, Input } from 'antd';
import ModalForm from 'components/ModalForm';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { EDIT_DASHBOARD } from 'shared/constants/permissions';
import useUser from 'hooks/useUser';

const QUERY = gql`
  query DashboardPage($id: ID!) {
    dashboardsPage(id: $id) {
      id
      title
      dashboards {
        id
        title
      }
    }
  }
`;

const CREATE_DASHBOARD_MUTATION = gql`
  mutation CreateDashboard($dashboardPageId: ID!, $input: DashboardInput!) {
    createDashboard(dashboardPageId: $dashboardPageId, input: $input) {
      id
    }
  }
`;

const DashboardSection = () => {
  const { data, loading, refetch } = useQuery(QUERY, {
    variables: { id: 'not implemented' },
  });
  const [createDashboard] = useMutation(CREATE_DASHBOARD_MUTATION);
  const [createDashboardOpen, setCreateDashboardOpen] = useState(false);
  const history = useHistory();
  const { path } = useRouteMatch();
  const { params } = useRouteMatch(`${path}/:id?`);
  const { hasPermission } = useUser();

  useEffect(() => {
    if (!params.id) {
      refetch();
    }
  }, [params.id]);

  const dashboardPage = data?.dashboardsPage;

  const canEdit = hasPermission(EDIT_DASHBOARD);

  const routes = dashboardPage?.dashboards?.map(d => ({
    path: d.id,
    label: d.title,
    component: Dashboard,
    props: {
      dashboardId: d.id,
    },
  })) || [];

  const onCreateDashboard = async (values) => createDashboard({ variables: { dashboardPageId: dashboardPage.id, input: { ...values } } });

  const onDashboardCreated = async (res) => {
    setCreateDashboardOpen(false);
    await refetch();
    history.push(`${path}/${res.data.createDashboard.id}`);
  };

  const afterMenu = canEdit ? (
    <div style={{ margin: 4, marginTop: 16 }}>
      <Button type="primary" block icon={<PlusOutlined />} onClick={() => setCreateDashboardOpen(true)}>Create Dashboard</Button>
      <ModalForm
        title="Create Dashboard"
        open={createDashboardOpen}
        onCancel={() => setCreateDashboardOpen(false)}
        onDone={onDashboardCreated}
        onSubmit={onCreateDashboard}
        okText="Create"
      >
        <Form.Item label="Title" name="title" rules={[{ required: true, message: 'Title is required' }]}>
          <Input />
        </Form.Item>
      </ModalForm>
    </div>
  ) : null;

  return (
    <RoutedLayout sidebar={{ afterMenu }} routes={routes} loading={loading} />
  );
};

export default DashboardSection;
